import { useForm } from '@inertiajs/vue3'

export const usePrintForm = (orderId) => {
  const printForm = useForm({
    orders: [orderId],
    print_receipt: true,
    print_sticker: true
  })

  const triggerPrintOrder = () => {
    printForm.post(route('orders.print'))
  }

  const triggerPrintOrderReceipt = () => {
    printForm
      .transform((data) => ({
        ...data,
        print_sticker: false
      }))
      .post(route('orders.print'))
  }

  const triggerPrintOrderSticker = () => {
    printForm
      .transform((data) => ({
        ...data,
        print_receipt: false
      }))
      .post(route('orders.print'))
  }

  return {
    printForm,
    triggerPrintOrder,
    triggerPrintOrderReceipt,
    triggerPrintOrderSticker
  }
}
